import { httpClientInternal } from './httpClient'

const END_POINT = '/checklist/account'

const VerificationChecklistAPI = {
  /**
   * Get account checklist items
   */
  async getAccountChecklistItems(accountId) {
    return await httpClientInternal.get(`${END_POINT}/${accountId}`)
  },

  async getAccountRepresentativeIdentityCheck(accountId) {
    return await httpClientInternal.get(`${END_POINT}/${accountId}/identity-check`)
  },

  async markChecklistItemReceived(accountId, checklistItemId) {
    return await httpClientInternal.patch(`${END_POINT}/${accountId}/item/${checklistItemId}/received`)
  },
}

export default VerificationChecklistAPI